import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import { UserCustomerType } from '@/types/apiTypes';
interface UserResponseType {
  id: string;
  username: string;
  firm: null;
  roles: string[];
  email: string;
  customer: UserCustomerType;
}

const useUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: async (): Promise<UserResponseType | null> => {
      const URL = `${import.meta.env.VITE_API_USER_ROLE_URL}`;

      const { data } = await axiosClient.get(URL);

      return data;
    },
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
};

export default useUser;
